__turbopack_context__.v({
  "content": "SingleColumnLayout-module-scss-module__eLVlEq__content",
  "main": "SingleColumnLayout-module-scss-module__eLVlEq__main",
  "map": "SingleColumnLayout-module-scss-module__eLVlEq__map",
});
